import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import siteConfigService, { WhiteLabelConfig } from '../../services/siteConfigService';

interface WhiteLabelState {
  config: WhiteLabelConfig | null;
  loading: boolean;
  error: string | null;
}

const initialState: WhiteLabelState = {
  config: null,
  loading: false,
  error: null,
};

export const fetchWhiteLabelConfig = createAsyncThunk(
  'whiteLabel/fetchConfig',
  async () => {
    const config = await siteConfigService.getWhiteLabelConfig();
    return config;
  }
);

const whiteLabelSlice = createSlice({
  name: 'whiteLabel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWhiteLabelConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWhiteLabelConfig.fulfilled, (state, action: PayloadAction<WhiteLabelConfig>) => {
        state.loading = false;
        state.config = action.payload ?? null;
      })
      .addCase(fetchWhiteLabelConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to load white label config';
      });
  },
});

export default whiteLabelSlice.reducer;
